import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TextAlignLeftIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TextAlignLeftIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TextAlignLeftIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TextAlignLeftIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="TextAlignLeftIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M4 4h16a1 1 0 0 1 1 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1zM4 9h9a1 1 0 0 1 1 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1zM4 14h16a1 1 0 0 1 1 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1zM4 19h9a1 1 0 0 1 1 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1z"
        clipRule="evenodd"
      />
    </svg>
  )
);
TextAlignLeftIcon.displayName = "TextAlignLeftIcon";
export default TextAlignLeftIcon;
